import { Navigate } from "react-router-dom";
import OrderDetails from "../components/allOrdersManagement/OrderDetails";
import CreditManagementScreen from "../components/creditNotes/creditNotesManagement/CreditManagementScreen";
import CreditNoteReceipt from "../components/creditNotes/creditReceiptGeneration/CreditNoteReceipt";
import CustomerDetails from "../components/customerManagement/CustomerDetails";
import DisplayCustomers from "../components/customerManagement/DisplayCustomers";
import InventoryDetails from "../components/inventoryManagement/InventoryDetails";
import InvoiceScreen from "../components/invoiceGeneration/InvoiceScreen";
import Ledger from "../components/ledger/Ledger";
import OrderSummary from "../components/orderSummary/OrderSummary";
import CreateNewProduct from "../components/productCatalogue/createNewProduct/CreateNewProduct";
import EditProduct from "../components/productCatalogue/createNewProduct/EditProduct";
import { ProductDetails } from "../components/productDetails/ProductDetails";
import ProductListing from "../components/productListing/ProductListing";
import Shipment from "../components/shipmentSummary/Shipment";
import ShipmentSummary from "../components/shipmentSummary/ShipmentSummary";
import UserManagement from "../components/userManagement/UserManagement";
import SalesRepManagementScreen from "../components/salesRepManagement/SalesRepManagementScreen";
import AgreementsPage from "../pages/shared/agreements";
import Prebookings from "../components/preBookings/PreBookings";
import SellerDashboard from "../pages/selller/dashboards";
import FinanceAnalytics from "../pages/selller/dashboards/finance-analytics";
import ClientManagementDashboard from "../pages/selller/dashboards/client-management";
import SalesRepresentativeDashboard from "../pages/selller/dashboards/sales-representative";
import SalesAnalyticsDashboard from "../pages/selller/dashboards/sales-analytics";
import AssigningOutlets from "../components/salesRepManagement/AssignOutlets";
import InvoiceHistory from "../components/invoiceGeneration/InvoiceHistory";
import ProfileManagement from "../components/profileManagement/ProfileManagement";
import FirstSellerSignInPage from "../pages/seller/FirstSellerSignInPage";

const sellerRoutes = [
  { path: "maltora-seller/products", element: <ProductListing /> },
  { path: "maltora-seller/products/product/:id", element: <ProductDetails /> },
  { path: "maltora-seller/edit-product/:id", element: <EditProduct /> },
  { path: "maltora-seller/create-new-product", element: <CreateNewProduct /> },
  { path: "maltora-seller/all-customers", element: <DisplayCustomers /> },
  { path: "maltora-seller/customer/:id", element: <CustomerDetails /> },
  { path: "maltora-seller/create-new-customer", element: <CustomerDetails /> },
  { path: "maltora-seller/profile-management", element: <ProfileManagement /> },
  { path: "maltora-seller/first-sign-in", element: <FirstSellerSignInPage /> },
  { path: "maltora-seller/user-management", element: <UserManagement /> },
  {
    path: "maltora-seller/sales-rep-management",
    element: <SalesRepManagementScreen />,
  },
  { path: "maltora-seller/orders", element: <OrderDetails /> },
  { path: "maltora-seller/order-summary/:id", element: <OrderSummary /> },
  { path: "maltora-seller/shipment", element: <Shipment /> },
  {
    path: "maltora-seller/shipment/shipment-summary",
    element: <ShipmentSummary />,
  },
  { path: "maltora-seller/inventory", element: <InventoryDetails /> },
  { path: "maltora-seller/invoice-screen/:id", element: <InvoiceScreen /> },
  {
    path: "maltora-seller/ledgers/credit-note/:id",
    element: <CreditNoteReceipt />,
  },
  { path: "maltora-seller/ledgers/:id", element: <Ledger /> },
  {
    path: "maltora-seller/credit-management",
    element: <CreditManagementScreen />,
  },
  { path: "maltora-seller/pre-bookings", element: <Prebookings /> },
  {
    path: "maltora-seller/sales-rep-management/assign-outlets",
    element: <AssigningOutlets />,
  },
  {
    path: "maltora-seller/customer/:id/agreement",
    element: <AgreementsPage />,
  },
  { path: "maltora-seller/invoice-history", element: <InvoiceHistory /> },
  {
    path: "maltora-seller/dashboard",
    element: <SellerDashboard />,
    children: [
      { path: "sales", element: <SalesAnalyticsDashboard /> },
      {
        path: "salesrep-analytics",
        element: <SalesRepresentativeDashboard />,
      },
      { path: "client-analytics", element: <ClientManagementDashboard /> },
      { path: "finance-analytics", element: <FinanceAnalytics /> },
      { index: true, element: <Navigate to="sales" replace /> },
    ],
  },
];

export default sellerRoutes;
